export default "__VITE_ASSET__bed7f26e__"